var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaived(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40263_68842)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 49,
    height: 49,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1648 28C39.162 28 37.2412 28.7902 35.8251 30.1967C34.4089 31.6032 33.6133 33.5109 33.6133 35.5C33.6133 37.4891 34.4089 39.3968 35.8251 40.8033C37.2412 42.2098 39.162 43 41.1648 43C43.1675 43 45.0883 42.2098 46.5045 40.8033C47.9206 39.3968 48.7162 37.4891 48.7162 35.5C48.7162 33.5109 47.9206 31.6032 46.5045 30.1967C45.0883 28.7902 43.1675 28 41.1648 28ZM41.1648 25C43.9687 25 46.6577 26.1062 48.6404 28.0754C50.623 30.0445 51.7368 32.7152 51.7368 35.5C51.7368 38.2848 50.623 40.9555 48.6404 42.9246C46.6577 44.8938 43.9687 46 41.1648 46C36.951 46 33.3112 43.54 31.6046 40H17V35.5C17 31.51 25.0499 29.5 29.0824 29.5C29.9886 29.5 31.1062 29.605 32.2842 29.8C33.2422 28.3261 34.557 27.1144 36.1085 26.2758C37.66 25.4373 39.3984 24.9986 41.1648 25ZM30.5927 35.5C30.5927 34.45 30.7437 33.43 31.0307 32.5C30.3963 32.395 29.7318 32.35 29.0824 32.35C24.5968 32.35 19.8696 34.54 19.8696 35.5V37.15H30.7286C30.6378 36.6046 30.5923 36.0528 30.5927 35.5ZM29.0824 16C30.6846 16 32.2212 16.6321 33.3541 17.7574C34.4871 18.8826 35.1236 20.4087 35.1236 22C35.1236 23.5913 34.4871 25.1174 33.3541 26.2426C32.2212 27.3679 30.6846 28 29.0824 28C27.4802 28 25.9436 27.3679 24.8106 26.2426C23.6777 25.1174 23.0412 23.5913 23.0412 22C23.0412 20.4087 23.6777 18.8826 24.8106 17.7574C25.9436 16.6321 27.4802 16 29.0824 16ZM29.0824 18.85C28.2412 18.85 27.4345 19.1819 26.8397 19.7726C26.2449 20.3634 25.9108 21.1646 25.9108 22C25.9108 22.8354 26.2449 23.6366 26.8397 24.2274C27.4345 24.8181 28.2412 25.15 29.0824 25.15C29.9235 25.15 30.7303 24.8181 31.3251 24.2274C31.9199 23.6366 32.254 22.8354 32.254 22C32.254 21.1646 31.9199 20.3634 31.3251 19.7726C30.7303 19.1819 29.9235 18.85 29.0824 18.85Z",
    fill: "#567FBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3423 33.3137C43.2986 33.2748 43.2636 33.228 43.2394 33.1759C43.2151 33.1239 43.2021 33.0677 43.201 33.0108C43.1999 32.9538 43.2109 32.8972 43.2333 32.8444C43.2556 32.7915 43.2888 32.7435 43.331 32.7033C43.3732 32.663 43.4234 32.6312 43.4787 32.6099C43.534 32.5885 43.5932 32.578 43.6528 32.579C43.7125 32.5801 43.7713 32.5925 43.8257 32.6157C43.8802 32.6389 43.9292 32.6723 43.9699 32.714L45.8942 34.5526L46.2081 34.8524L45.8942 35.1523L43.9699 36.9908C43.8857 37.0658 43.7744 37.1066 43.6593 37.1046C43.5443 37.1027 43.4345 37.0582 43.3532 36.9804C43.2718 36.9027 43.2252 36.7978 43.2232 36.6879C43.2211 36.578 43.2638 36.4716 43.3423 36.3912L44.5087 35.2767H38.6587C38.5226 35.2767 38.3879 35.3023 38.2622 35.3521C38.1365 35.4018 38.0222 35.4747 37.926 35.5667C37.8298 35.6586 37.7535 35.7677 37.7014 35.8879C37.6493 36.008 37.6225 36.1367 37.6225 36.2667C37.6225 36.3967 37.6493 36.5255 37.7014 36.6456C37.7535 36.7657 37.8298 36.8748 37.926 36.9668C38.0222 37.0587 38.1365 37.1316 38.2622 37.1814C38.3879 37.2311 38.5226 37.2567 38.6587 37.2567H39.8429C39.9607 37.2567 40.0737 37.3014 40.1569 37.381C40.2402 37.4606 40.287 37.5685 40.287 37.681C40.287 37.7935 40.2402 37.9015 40.1569 37.981C40.0737 38.0606 39.9607 38.1053 39.8429 38.1053H38.6587C38.1483 38.1053 37.6589 37.9116 37.298 37.5668C36.9371 37.222 36.7344 36.7543 36.7344 36.2667C36.7344 35.7791 36.9371 35.3114 37.298 34.9666C37.6589 34.6218 38.1483 34.4281 38.6587 34.4281H44.5087L43.3423 33.3137Z",
    fill: "#567FBD",
    stroke: "#567FBD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40263_68842",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40263_68842"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40263_68842",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaived);
export default __webpack_public_path__ + "static/media/Waived.159c9d85cbcc8421f777d521ddfbd4ef.svg";
export { ForwardRef as ReactComponent };